<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <!-- <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3"> -->
            <!-- :initialSelectedKey="this.$store.getters.userInfo.siteId" -->
            <!-- <cmp-site-select
              ref="srchSite"
              :selected="frame0.selectData.COD_SITE"
              :page-id="this.$options.name"
              initialSelectedKey="ALL"
              defaultOption="all"
            />
          </div> -->
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="condType"
              :selected="frame0.selectData.COD_COND"
              codeId="COD_MANU_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.searchWord"
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsManual'"
        :multiselect="false"
        :initial-pagesize="10"
        :showDisplayCountControl="false"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="onClickDelete"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onClickRegist"
        >
          {{ $t("MSG_BTN_RGST") }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMU_00010', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_COND: {
            label: '',
            key: '',
          },
        },
        searchWord: '',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsManual',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'documentId', type: 'string', map: 'documentId' },
      { name: 'documentClassificationCode', type: 'string', map: 'documentClassificationCode' },
      { name: 'documentGeneralTypeCode', type: 'string', map: 'documentGeneralTypeCode' },
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'subModuleCode', type: 'string', map: 'subModuleCode' },
      { name: 'documentVersion', type: 'string', map: 'documentVersion' },
      { name: 'documentContent', type: 'string', map: 'documentContent' },
      { name: 'documentMultiLanguageId', type: 'string', map: 'documentMultiLanguageId' },
      { name: 'documentFileSN', type: 'string', map: 'documentFileSN' },
      { name: 'attachDocumentId', type: 'string', map: 'attachDocumentId' },
      { name: 'langId', type: 'string', map: 'langId' },
      { name: 'documentDetailContent', type: 'string', map: 'documentDetailContent' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageCount', type: 'string', map: 'pageCount' },
      { name: 'pageIdCount', type: 'string', map: 'pageIdCount' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'documentName', type: 'string', map: 'documentName' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'finalModificationUserName', type: 'string', map: 'finalModificationUserName' },
      { name: 'knoxIdModification', type: 'string', map: 'knoxIdModification' },
      { name: 'knoxIdRegistration', type: 'string', map: 'knoxIdRegistration' },
      { name: 'loginIdModification', type: 'string', map: 'loginIdModification' },
      { name: 'loginIdRegistration', type: 'string', map: 'loginIdRegistration' },
      { name: 'userNameModification', type: 'string', map: 'userNameModification' },
      { name: 'userNameRegistration', type: 'string', map: 'userNameRegistration' },
      { name: 'userGlobalNameModification', type: 'string', map: 'userGlobalNameModification' },
      { name: 'userGlobalNameRegistration', type: 'string', map: 'userGlobalNameRegistration' },
      { name: 'departmentNameModification', type: 'string', map: 'departmentNameModification' },
      { name: 'departmentNameRegistration', type: 'string', map: 'departmentNameRegistration' },
      { name: 'departmentEnglishNameModification', type: 'string', map: 'departmentEnglishNameModification' },
      { name: 'departmentEnglishNameRegistration', type: 'string', map: 'departmentEnglishNameRegistration' },
      { name: 'displayLanguageIdModification', type: 'string', map: 'displayLanguageIdModification' },
      { name: 'displayLanguageIdRegistration', type: 'string', map: 'displayLanguageIdRegistration' },
    ],
  }],
  created() {
    this.gridColumns0 = [{
      text: this.$t('MSG_TXT_MDLE'),
      datafield: 'moduleName',
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_SMDLE'),
      datafield: 'subModuleName',
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_MANU_ID'),
      datafield: 'documentId',
      width: '150px',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
          handler: this.onGridSingleButtonClicked,
          type: 'link',
        }, this.dsManual, this.$refs.grid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_MANU_NM'),
      datafield: 'documentName',
    },
    // {
    //   text: this.$t('MSG_TXT_APPY_PAGE_ID'),
    //   datafield: 'pageIdCount',
    //   width: '150px',
    // },
    {
      text: this.$t('MSG_TXT_MDFC_USR'),
      datafield: 'finalModificationUserName',
      width: '200px',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1', // "1", "2" - default: "1"
          type: 'link', // 'link', 'sublink' - default: "link"
          datafieldMap: {
            displayLanguageId: 'displayLanguageIdModification',
            knoxId: 'knoxIdModification',
            userName: 'userNameModification',
            userGlobalName: 'userGlobalNameModification',
            departmentName: 'departmentNameModification',
            departmentEnglishName: 'departmentEnglishNameModification',
            loginId: 'loginIdModification',
          },
        }, this.dsManual, this.$refs.grid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_MDFC_DTM'),
      datafield: 'finalModificationDTM',
      width: '150px',
    }];
    this.localdata0 = [];
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     *  초기화
     */
    onClickReset() {
      // this.$refs.smComboFrame0.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.condType.reset();

      this.frame0.searchWord = '';
    },
    /**
     *  검색
     *  매뉴얼 목록 조회
     */
    onClickSearch() {
      const queryParams = {
        moduleCode: this.frame0.selectData.COD_MDLE.key,
        subModuleCode: this.frame0.selectData.COD_SMDLE.key,
        searchWord: this.frame0.searchWord,
        searchCond: this.frame0.selectData.COD_COND.key,
      };

      http.request(this.$options.name, 'DTS_CMU_00055', {
        query: queryParams,
      }).then(res => {
        let pageIdCount = '';

        utils.dateformatToClientInArray(res.data, dateFields);
        utils.forEach(res.data, (obj, key) => {
          if (obj.pageCount > 1) {
            pageIdCount = utils.strFormat(this.$t('MSG_TXT_EXID_CNT'), obj.pageId, obj.pageCount);
          } else {
            pageIdCount = obj.pageId;
          }

          res.data[key].pageIdCount = pageIdCount;
        });

        this.dsManual.setRawData(res.data);
      });
    },
    /**
     *  삭제
     */
    onClickDelete() {
      if (!(this.dsManual.getSelectedIndexes().length > 0)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM')); // 선택 된 항목이 없습니다.
        return false;
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_DO_DELETE'), null, () => {
        http.request(this.$options.name, 'DTS_CMU_00059', {
          data: this.dsManual.getSelectedRawData(),
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, () => {
            this.onClickSearch();
          });
        });
      });

      return null;
    },
    /**
     *  매뉴얼 수정 팝업 호출
     */
    onGridSingleButtonClicked(value, dataRow) {
      utils.openLayerPopup('PGE_CMU_00011', this.manualPopupCallback, {
        pageInitialData: {
          manualId: dataRow.documentId,
        },
        size: 'lg',
        title: this.$t('MSG_TIT_MANU_MOD'),
      });
    },
    /**
     *  매뉴얼 등록 팝업 호출
     */
    onClickRegist() {
      utils.openLayerPopup('PGE_CMU_00011', this.manualPopupCallback, {
        pageInitialData: {},
        size: 'lg',
        title: this.$t('MSG_TIT_MANU_RGST'),
      });
    },
    /**
     *  매뉴얼 등록/수정 팝업 CALLBACK
     */
    manualPopupCallback() {
      this.onClickSearch();
    },
  },
};
</script>
<style scoped>
</style>
